import React, { useState } from "react";
import { useGridApiRef } from "@mui/x-data-grid";
import { useEnquiryContext } from "../context";
import { EnquiryTopBanner } from "../components/EnquiryTopBanner";
import { enquiryOperationsList } from "../constants/enquiry.constants";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { useGlobalContext } from "context/GlobalContext";
import { statusUpdateEnquiryApi } from "API/apis/enquiry/statusUpdateEnquiry";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { confirmAction } from "utils/functions/confirmAction";
import { message } from "constants/responses/message";
import { enquiryListColumnsL } from "../responsiveData/enquiryListColumnsL";
import { enquiryListColumnsS } from "../responsiveData/enquiryListColumnsS";
import { ReactTable } from "components/ReactTable/ReactTable";
import { useSelector } from "react-redux";

export const EnquiryList = () => {
  const { setIsLoading, setSuccess, setError, isMobile } = useGlobalContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const {
    list,
    setList,
    setCurrentOperationPage,
    setPreviewEnquiry,
    reloadRequired,
    setReloadRequired,
  } = useEnquiryContext();
  const [selectedRowId, setSelectedRowId] = useState();
  const curUserId = useSelector((state) => state.user.state.userId);
  const handleChangeStatus = async (statusSelected, statusRowId) => {
    try {
      const confirmed = confirmAction(message.info.generalConfirmBoxMessage);
      if (!confirmed) {
        setAnchorEl(null);
        return;
      }
      setIsLoading(true);
      const { data, status } = await statusUpdateEnquiryApi({
        status: statusSelected,
        id: statusRowId,
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      const listIndex = list.findIndex((item) => item.id === statusRowId);
      list[listIndex].status = statusSelected;
      setList(list);
      setSuccess(data?.message);
      setCurrentOperationPage(enquiryOperationsList.listEnquiry);
      setReloadRequired(!reloadRequired);
    } catch (error) {
      setError(error.message);
    } finally {
      setAnchorEl(null);
      setIsLoading(false);
    }
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleLink = (link) => {
    window.open(link, "_BLANK");
  };
  const handleEdit = (row) => {
    setPreviewEnquiry(row);
    setCurrentOperationPage(enquiryOperationsList.updateEnquiry);
  };
  const handleRowClick = (row) => {
    setPreviewEnquiry(row);
    setCurrentOperationPage(enquiryOperationsList.previewEnquiry);
  };
  const handleTaskButtonClick = (row) => {
    setPreviewEnquiry(row);
    setCurrentOperationPage(enquiryOperationsList.enquiryTask);
  };
  return (
    <>
      <PageTitle pageName={pageName.enquiry.equityList} />
      <EnquiryTopBanner
        enquiryOperationsParam={enquiryOperationsList.newEnquiry}
        buttonType="add"
      />
      <div style={{ width: "100%" }}>
        <ReactTable
          columns={
            isMobile
              ? enquiryListColumnsS({
                  handleRowClick,
                  handleLink,
                  handleClick,
                  handleEdit,
                  handleChangeStatus,
                  open,
                  anchorEl,
                  setAnchorEl,
                  handleTaskButtonClick,
                  curUserId,
                })
              : enquiryListColumnsL({
                  handleRowClick,
                  handleLink,
                  handleClick,
                  handleEdit,
                  handleChangeStatus,
                  open,
                  anchorEl,
                  setAnchorEl,
                  handleTaskButtonClick,
                  curUserId,
                })
          }
          data={list}
          selectedRowId={selectedRowId}
          setSelectedRowId={setSelectedRowId}
        />
      </div>
    </>
  );
};
